import React from 'react'
import img from '../../Image/notfound.svg'
const NotFound = () => {
    return (
        <div className='flex items-center justify-center w-full mt-4'>
            <img src={img} alt="Not Found" className='h-[180px]' />
        </div>
    )
}

export default NotFound